export default {
    description: "Popis",
    orderingNote: "Poznámka k objednávce"
}